import { ClassNameProps } from "@/types";
import { VideoProps } from "@/components/atoms/Video/types";

enum OrientationLockType {
  Landscape = "landscape",
  Portrait = "portrait",
  LandscapePrimary = "landscape-primary",
  LandscapeSecondary = "landscape-secondary",
  PortraitPrimary = "portrait-primary",
  PortraitSecondary = "portrait-secondary",
  Natural = "natural",
  Any = "any",
}

interface ScreenOrientationWithLock {
  lock(orientation: OrientationLockType): Promise<void>;
  unlock(): void;
}

interface VideoPlayerProps extends ClassNameProps {
  /* Video component props */
  videoProps: VideoProps;

  /* Whether to display as fullscreen modal */
  isModal?: boolean;

  /* Callback when modal is closed (only used when isModal is true) */
  onClose?: () => void;

  /* Number of seconds to skip */
  skipSeconds?: number;

  /* Whether to show video controls */
  showControls?: boolean;
}

export { OrientationLockType };
export type { VideoPlayerProps, ScreenOrientationWithLock };
